<template lang="pug">
    section.article-stocks-tab
        transition(name="slide-decent-vertical" mode="out-in")
            el-alert(
                v-if="!options.stock.items.length"
                type="warning"
                :title="$t('This shop has no stock configured.')"
                effect="dark"
                :closable="false"
            )
            el-alert(
                v-else-if="!form.stocks.length"
                type="warning"
                :title="$t('This Article has no stock.')"
                effect="dark"
                :closable="false"
            )
            .stocks(v-else)
                transition-group(name="slide-decent-vertical" tag="div")
                    Stock(
                        v-for="stock in stocks" :key="stock.i"
                        :stock="stock"
                        :form="form"
                        :rules="rules"
                        :block="stocks.length > 1"
                    )

        el-button.add-stock(
            v-if="options.stock.items.length && ! form.stocks.length"
            type="primary"
            icon="el-icon-fa-plus fas"
            @click="addStock"
        ) {{ $t('Add stock') }}
        el-button(
            v-else-if="options.stock.items.length > form.stocks.length"
            type="primary"
            icon="el-icon-fa-plus fas"
            @click="addStock"
        ) {{ $t('Add article to a different stock') }}

</template>

<i18n>
{
    "de": {
        "This shop has no stock configured.": "Dieser Shop hat keine Lagerkonfiguration.",
        "This Article has no stock.": "Dieser Artikel hat keinen Lagerbestand.",
        "This Article is not assigned to any stock.": "Dieser Artikel ist keinem Lager zugeordnet.",
        "Add article to a different stock": "Lagerbestand an einem anderen Ort hinzufügen",
        "Add stock": "Lagerbestand hinzufügen"
    }
}
</i18n>

<script>
import pinia from '@/pinia';
import { useShopArticleStore } from '@/stores';

import Stock from './Stock';

export default {
    name: 'ArticleStocksTab',
    components: {
        Stock
    },
    computed: {
        shopArticleStore() {
            return useShopArticleStore(pinia);
        },
        stocks() {
            // NOTE: add iterator to collection
            // to prevent animation on stock change
            let stocks = [];
            this.form.stocks.forEach((el, i) => {
                stocks.push({ ...el, i });
            });
            return stocks;
        },
        form() {
            return this.shopArticleStore.form;
        },
        rules() {
            return this.shopArticleStore.rules;
        },
        options() {
            return this.shopArticleStore.options;
        }
    },
    methods: {
        addStock() {
            let id, name, status, restriction, customerGroups;

            // get id and name from available stock option
            this.options.stock.items.forEach(stock => {
                if (id === undefined && !this.form.stocks.find(el => el.id === stock.id)) {
                    id = stock.id;
                    name = stock.name;
                    status = stock.status;
                    restriction = stock.restriction;
                    customerGroups = stock.customerGroups;
                }
            });

            if (id !== undefined) {
                this.addArticleStock({
                    id,
                    name,
                    status,
                    restriction,
                    customerGroups,
                    pivot: {
                        qty: 0,
                        restriction: null,
                        customerGroups: [],
                        sellable_from: null,
                        sellable_to: null,
                    }
                });
            }
        },
        addArticleStock(stock) {
            this.shopArticleStore.addFormStock(stock);
        }
    }
};
</script>

<style lang="sass" scoped>
.el-button.add-stock
    margin-top: 25px
.el-alert
    margin-bottom: 14px
</style>
